import { uiAppName } from '@nova/core';

export type JunoEnvVars = {
  ui_app_name: string;
  server_env: string;
  neutron_url: string;
  unleash_app_name: string;
  unleash_url: string;
  unleash_client_key: string;
  mixpanel_token?: string;
};

type JunoConfig = JunoEnvVars & { application_name: string };

// We enforce env vars here so it's consistent across all environments
function must<K extends keyof JunoEnvVars>(env: Partial<JunoEnvVars>, key: K): JunoEnvVars[K] {
  const envVarVal = env[key];
  if (!envVarVal) {
    throw new Error(`Missing env ${String(key)}`);
  }
  return envVarVal;
}

function getUnleashUrl(env: Partial<JunoEnvVars>) {
  const { unleash_url, neutron_url } = env;
  const url = unleash_url ? unleash_url.trim() : null;
  if (url) {
    return url;
  }
  return new URL('/feature-flag/proxy', neutron_url).toString();
}

function getUnleashClientKey(env: Partial<JunoEnvVars>) {
  const { unleash_client_key } = env;
  const key = unleash_client_key ? unleash_client_key.trim() : null;
  if (key) {
    return key;
  }
  const token =
    (sessionStorage?.getItem('access_token') || localStorage?.getItem('access_token')) ?? '';
  return `Bearer ${token || ''}`;
}

const formattedVars: Partial<JunoEnvVars> = Object.entries(import.meta.env).reduce(
  (env, [key, value]) => ({ ...env, [key.replace('VITE_', '').toLowerCase()]: value }),
  {} as Partial<JunoEnvVars>
);

const config: JunoConfig = {
  ...formattedVars,
  ...{
    ui_app_name: uiAppName.JUNO,
    application_name: 'Opendock Nova',
    unleash_app_name: 'opendock-nova',
    unleash_url: getUnleashUrl(formattedVars),
    unleash_client_key: getUnleashClientKey(formattedVars),
    server_env: must(formattedVars, 'server_env'),
    neutron_url: must(formattedVars, 'neutron_url')
  }
};

export default config;
